import { axiosDefault } from '@/core/utils';

const buyProduct = async (id: string) => {
	const url = `/tg/product/${id}/purchase`;
	const response = await axiosDefault.post(url);
	return response.data;
};

const checkPurchase = async () => {
	const url = `/tg/product/purchase/pending`;
	const response = await axiosDefault.get(url);
	return response.data;
};

export const ShopService = {
	buyProduct,
	checkPurchase,
};
